module.exports = __webpack_public_path__ + "img/iphone6_wechat.d499bbee.png";